import { trpc } from "../../utils/trpc";
import { Banner } from "./base_components/banner";

export function StatusBanner(props: {}) {
	const status_message_query = trpc.misc.getStatusMessage.useQuery();

	if (!status_message_query.data) {
		return <></>;
	}

	return <Banner>{status_message_query.data}</Banner>;
}
